import React from 'react';
import {SHOPIFY_PRODUCTS_PRICE_FIELDS_LIST} from "../../constants/shopify-product-price-sync.constant";
import {showDateTime} from "../../../printful/utils/printful-util";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";


const ProductPriceList = ({productPrices}) => {

    return (
        <>

            <ShowEmptyListMessage
                dataList={productPrices || []}
                dataFetchInProgress={false}
                label={'Products Prices'}/>

            {productPrices?.length > 0 &&
                <div
                    className={''}>
                    <table className="w-full">
                        <thead className="">
                        <tr>
                            <th className="p-2 border border-gray-400 bg-gray-400 sticky top-0 table-header-label w-12">S.No</th>
                            {SHOPIFY_PRODUCTS_PRICE_FIELDS_LIST?.map((productsPriceField, rowIndex) => (
                                <th key={`th-${rowIndex}`}
                                    className={`p-2 border border-gray-400 bg-gray-400 sticky top-0 table-header-label text-left pl-2 ${productsPriceField?.cssClass}`}>{productsPriceField?.label}</th>
                            ))}
                        </tr>
                        </thead>
                        <tbody className="">
                        {productPrices?.map((printfulProductsPrice, rowIndex) => (
                            <tr key={`row-${rowIndex}`}
                                className={`border border-gray-400 ${printfulProductsPrice?.sync ? 'bg-purple-100' : ''}`}>
                                <td className="p-2 border border-gray-400 m-auto">
                                    <div className="flex justify-center w-12">
                                        {rowIndex + 1}
                                    </div>
                                </td>

                                {SHOPIFY_PRODUCTS_PRICE_FIELDS_LIST?.map((printfulProductsPriceField, columnIndex) => (
                                    <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                        <td className={`p-2 border border-gray-400 m-auto ${printfulProductsPriceField?.cssClass}`}>
                                            {printfulProductsPriceField?.optionsMap &&
                                                <>
                                                    {printfulProductsPriceField?.optionsMap[printfulProductsPrice[printfulProductsPriceField?.attribute]]?.name}
                                                </>
                                            }

                                            {!printfulProductsPriceField?.optionsMap &&
                                                <>
                                                    {!printfulProductsPriceField?.isDate &&
                                                        <>
                                                            {printfulProductsPriceField?.prefix &&
                                                                <>{printfulProductsPriceField?.prefix} </>
                                                            }

                                                            {printfulProductsPriceField?.isTitle &&
                                                                <>
                                                                    <div>
                                                                        {printfulProductsPrice[printfulProductsPriceField?.attribute]}
                                                                    </div>

                                                                    <div>
                                                                        {printfulProductsPriceField?.otherAttributes.map((otherAttribute, otherAttributeIndex) => (
                                                                            <span
                                                                                className={'text-gray-500 font-normal'}
                                                                                key={`other-attribute-${otherAttributeIndex}`}>
                                                                                        {otherAttributeIndex !== 0 &&
                                                                                            <span
                                                                                                className={'text-gray-400'}> | </span>
                                                                                        }

                                                                                {printfulProductsPrice[otherAttribute]}
                                                                                    </span>
                                                                        ))}
                                                                    </div>

                                                                </>
                                                            }

                                                            {!printfulProductsPriceField?.isTitle &&
                                                                <>
                                                                    {printfulProductsPrice[printfulProductsPriceField?.attribute]}
                                                                </>
                                                            }

                                                            {printfulProductsPriceField?.suffix &&
                                                                <> {printfulProductsPriceField?.suffix}</>
                                                            }
                                                        </>
                                                    }

                                                    {printfulProductsPriceField?.isDate &&
                                                        <>
                                                            {showDateTime(printfulProductsPrice[printfulProductsPriceField?.attribute])}
                                                        </>
                                                    }

                                                    {printfulProductsPriceField?.secondaryAttribute &&
                                                        <div className={'text-gray-500 text-sm'}>
                                                            {printfulProductsPrice[printfulProductsPriceField?.secondaryAttribute]}
                                                        </div>
                                                    }
                                                </>
                                            }
                                        </td>
                                    </React.Fragment>
                                ))}

                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            }

        </>
    )
}

export default ProductPriceList
